import React from 'react';
import { Typography, useMediaQuery, useTheme } from "@material-ui/core";

const DesktopOnlyText = ({children, ...props}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return !isMobile && <Typography {...props}>
        {children}
    </Typography>
}

export default DesktopOnlyText;
